import { Languages } from "../../enums/languages";
import { IMessageDescrption } from "../../interface/API/apiError.interface";


const defualtLolaTechHttpErrorsLang: IMessageDescrption = {
    'INVALID_RESPONSE_API': {
        [Languages.Hebrew]: { default: 'קיבלנו תשובה לא תקינה מהשרת, אנא נסה שוב או פנה לתמיכה' },
        [Languages.Arabic]: { default: 'تلقينا استجابة غير صالحة من الخادم، يرجى المحاولة مرة أخرى أو الاتصال بالدعم' },
        [Languages.English]: { default: 'Received an invalid response from the server, please try again or contact support' }
    },
    'GENERAL_ERROR_FRONT_END': {
        [Languages.Hebrew]: { default: 'אירעה שגיאה באתר, אנא נסה שוב או פנה לתמיכה' },
        [Languages.Arabic]: { default: 'حدث خطأ في الموقع، يرجى المحاولة مرة أخرى أو الاتصال بالدعم' },
        [Languages.English]: { default: 'An error occurred on the website, please try again or contact support' }
    },
    'OTP_CODE_VERIFICATION_FAILED': {
        [Languages.Hebrew]: { default: 'אימות קוד האימות הזמני נכשל, אנא נסה שוב' },
        [Languages.Arabic]: { default: 'فشل التحقق من رمز التحقق المؤقت، يرجى المحاولة مرة أخرى' },
        [Languages.English]: { default: 'Temporary OTP code verification failed, please try again' }
    },
    'GENERAL_ERROR': {
        [Languages.Hebrew]: { default: 'בעיה כללית בשרת, אנא פנה לתמיכה' },
        [Languages.Arabic]: { default: 'مشكلة عامة في الخادم، يرجى الاتصال بالدعم' },
        [Languages.English]: { default: 'General server error, please contact support' }
    },
    'BAD_REQUEST': {
        [Languages.Hebrew]: { default: 'לא נשלחו כל הנתונים לשרת' },
        [Languages.Arabic]: { default: 'لم يتم إرسال جميع البيانات إلى الخادم' },
        [Languages.English]: { default: 'Not all data was sent to the server' }
    },
    'OTP_ERROR': {
        [Languages.Hebrew]: { default: 'קוד אימות זמני לא תקין' },
        [Languages.Arabic]: { default: 'رمز التحقق المؤقت غير صالح' },
        [Languages.English]: { default: 'The temporary OTP code is not valid' }
    },
    'PORTAL_ACTION_NOT_ALLOWED': {
        [Languages.Hebrew]: { default: 'אין לך הרשאה לבצע פעולה זו' },
        [Languages.Arabic]: { default: 'ليس لديك إذن لتنفيذ هذا الإجراء' },
        [Languages.English]: { default: 'You do not have permission to perform this action' }
    },
    'DATA_NOT_FOUND': {
        [Languages.Hebrew]: { default: 'המידע המבוקשת אינו קיים' },
        [Languages.Arabic]: { default: 'المعلومات المطلوبة غير موجودة' },
        [Languages.English]: { default: 'The requested information does not exist' }
    },
    'SYSTEM_TABLE_NOT_FOUND': {
        [Languages.Hebrew]: { default: 'טבלת המערכת המבוקשת לא נמצאה' },
        [Languages.Arabic]: { default: 'جدول النظام المطلوب غير موجود' },
        [Languages.English]: { default: 'The requested system table was not found' }
    },
    'SQL_ROW_NOT_FOUND': {
        [Languages.Hebrew]: { default: 'השורה המבוקשת לא נמצאה במערכת' },
        [Languages.Arabic]: { default: 'الصف المطلوب غير موجود في النظام' },
        [Languages.English]: { default: 'The requested row was not found in the system' }
    },
    'CITIZEN_STICKER_NOT_FOUND': {
        [Languages.Hebrew]: { default: 'לא נמצא בקשה לתו עם מספר רכב ותעודת זהות תואמים' },
        [Languages.Arabic]: { default: 'لم يتم العثور على ملصق موقف صالح للمستخدم' },
        [Languages.English]: { default: 'No valid parking sticker found for the user' }
    },
    'PERMIT_NOT_FOUND': {
        [Languages.Hebrew]: { default: 'לא נמצא היתר חניה תקף עבור המשתמש' },
        [Languages.Arabic]: { default: 'لم يتم العثور على تصريح موقف صالح للمستخدم' },
        [Languages.English]: { default: 'No valid parking permit found for the user' }
    },
    'VALID_EMAIL_NOT_FOUND': {
        [Languages.Hebrew]: { default: 'האימייל שנמצא במערכת אינו תקין או לא קיים' },
        [Languages.Arabic]: { default: 'البريد الإلكتروني الموجود في النظام غير صالح أو غير موجود' },
        [Languages.English]: { default: 'The email found in the system is invalid or does not exist' }
    },
    'VALID_MOBILE_NOT_FOUND': {
        [Languages.Hebrew]: { default: 'מספר הנייד שנמצא במערכת אינו תקין או לא קיים' },
        [Languages.Arabic]: { default: 'رقم الهاتف المحمول الموجود في النظام غير صالح أو غير موجود' },
        [Languages.English]: { default: 'The mobile number found in the system is invalid or does not exist' }
    },
    'FILE_GENERAL': {
        [Languages.Hebrew]: { default: 'תהליך נכשל - התרחשה בעיה בתהליך העלאת הקבצים.' },
        [Languages.Arabic]: { default: 'فشل العملية - حدثت مشكلة في عملية تحميل الملفات.' },
        [Languages.English]: { default: 'Process failed - an issue occurred during the file upload process.' }
    },
    'FILE_SIZE': {
        [Languages.Hebrew]: { default: 'תהליך נכשל - אחד או יותר מהקבצים גדולים מהגודל המותר.' },
        [Languages.Arabic]: { default: 'فشل العملية - واحد أو أكثر من الملفات أكبر من الحجم المسموح به.' },
        [Languages.English]: { default: 'Process failed - one or more files are larger than the allowed size.' }
    },
    'FILE_TYPE_NOT_SUPPORTED': {
        [Languages.Hebrew]: { default: 'תהליך נכשל - אחד או יותר מהקבצים מסוג לא נתמך.' },
        [Languages.Arabic]: { default: 'فشل العملية - واحد أو أكثر من الملفات من نوع غير مدعوم.' },
        [Languages.English]: { default: 'Process failed - one or more files are of an unsupported type.' }
    },
    'FILE_CONVERSION': {
        [Languages.Hebrew]: { default: 'תהליך נכשל - התרחשה בעיה בתהליך המרת הקבצים.' },
        [Languages.Arabic]: { default: 'فشل العملية - حدثت مشكلة في عملية تحويل الملفات.' },
        [Languages.English]: { default: 'Process failed - an issue occurred during the file conversion process.' }
    },
    'CAR_HASH_MAP_PAYMENT': {
        [Languages.Hebrew]: { default: 'תהליך נכשל - בעיה כללית בשרת במהלך תהליך התשלום' },
        [Languages.Arabic]: { default: 'فشل العملية - مشكلة عامة في الخادم أثناء عملية الدفع' },
        [Languages.English]: { default: 'Process failed - a general server issue occurred during the payment process' }
    },
    'TRANZILA_PAYMENT': {
        [Languages.Hebrew]: { default: 'בעיה בתהליך סליקת כרטיס האשראי. אנא בדוק תקינות כרטיס האשראי. במידת הצורך, אנא פנה לחברת האשראי לצורך בדיקה' },
        [Languages.Arabic]: { default: 'مشكلة في عملية معالجة بطاقة الائتمان. يرجى التحقق من صحة بطاقة الائتمان. إذا لزم الأمر، يرجى الاتصال بشركة الائتمان للتحقق' },
        [Languages.English]: { default: 'Issue in the credit card processing. Please check the validity of the credit card. If necessary, please contact the credit card company for verification' }
    },
    'GENERAL_PAYMENT_ERROR': {
        [Languages.Hebrew]: { default: 'תהליך נכשל - התרחשה בעיה בתהליך התשלום, יש לפנות לעזרה.' },
        [Languages.Arabic]: { default: 'فشل العملية - حدثت مشكلة في عملية الدفع، يرجى طلب المساعدة.' },
        [Languages.English]: { default: 'Process failed - an issue occurred during the payment process, please seek assistance.' }
    },
    'ALLOW_ONLY_ONE_HEAVY_HEVICLE_PERMIT': {
        [Languages.Hebrew]: { default: 'תהליך נכשל - ניתן להנפיק רק תו כבד אחד לכל תעודת זהות' },
        [Languages.Arabic]: { default: 'فشل العملية - يمكن إصدار تصريح واحد فقط لكل بطاقة هوية' },
        [Languages.English]: { default: 'Process failed - only one heavy vehicle permit can be issued per ID' }
    },
    'VALID_REQUEST_ALREADY_EXIST': {
        [Languages.Hebrew]: { default: 'קיימת בקשה שממתינה לאישור עם מספר רכב ותעודת זהות זהים' },
        [Languages.Arabic]: { default: 'يوجد طلب في انتظار الموافقة بنفس رقم السيارة والهوية' },
        [Languages.English]: { default: 'There is a request pending approval with the same car number and ID' }
    },
    'VALID_PERMIT_ALREADY_EXIST': {
        [Languages.Hebrew]: { default: 'קיים במערכת תו עם מספר רכב ותעודת זהות זהים' },
        [Languages.Arabic]: { default: 'يوجد في النظام تصريح بنفس رقم السيارة والهوية' },
        [Languages.English]: { default: 'There is a permit in the system with the same car number and ID' }
    },
    'VALID_PERMIT_ALREADY_EXISTS_FOR_CITIZEN': {
        [Languages.Hebrew]: { default: 'קיים במערכת תו עם מספר רכב ותעודת זהות זהים' },
        [Languages.Arabic]: { default: 'يوجد في النظام تصريح بنفس رقم السيارة والهوية' },
        [Languages.English]: { default: 'There is a permit in the system with the same car number and ID' }
    },
    'VALID_REQ_ALREADY_EXISTS_FOR_CITIZEN': {
        [Languages.Hebrew]: { default: 'קיימת בקשה שממתינה לאישור עם מספר רכב ותעודת זהות זהים' },
        [Languages.Arabic]: { default: 'يوجد طلب في انتظار الموافقة بنفس رقم السيارة والهوية' },
        [Languages.English]: { default: 'There is a request pending approval with the same car number and ID' }
    },
    'TOO_MANY_PERMITS_OF_SAME_PERSON_AND_DIFF_CAR': {
        [Languages.Hebrew]: { default: 'תהליך נכשל - קיימים במערכת יותר מדי תווים של אותו אדם עם מספרי רכב שונים' },
        [Languages.Arabic]: { default: 'فشل العملية - يوجد في النظام الكثير من التصاريح لنفس الشخص بأرقام سيارات مختلفة' },
        [Languages.English]: { default: 'Process failed - there are too many permits in the system for the same person with different car numbers' }
    }
}

export default defualtLolaTechHttpErrorsLang;